import useInfiniteFetch from '@hooks/useInfiniteFetch';

const getFormattedPaginationResults = (data) => {
  if (data?.length) {
    return data.length > 1
      ? data.reduce((accumulator, currentValue) => {
          return {
            ...accumulator,
            count: accumulator.count,
            next: currentValue.next,
            schedule: [
              ...(accumulator.schedule || []),
              ...(currentValue.schedule || [])
            ]
          };
        })
      : { ...data[0], schedule: data[0].schedule, count: data[0].count };
  }
};

// http://local.unacademy.com:8080/batch-group/test-thumbnail-7/EOI9FBWI
const defaultLimit = 10;
const useCurriculum = (
  url,
  limit = defaultLimit,
  classType,
  options = { fallbackData: undefined }
) => {
  const date = new Date();
  const timezoneDifference = date.getTimezoneOffset() * -1;
  const key = `${url}?timezone_difference=${timezoneDifference}&class_type=${classType}`;
  const {
    data: curriculumData,
    rawData,
    isValidating,
    isError,
    ...rest
  } = useInfiniteFetch(
    key,
    { limit, hasQueryParams: true },
    {
      persistSize: true,
      revalidateFirstPage: false,
      fallbackData: options.fallbackData
    }
  );
  return {
    key,
    curriculumData:
      rawData && rawData.length > 0 && !isError
        ? getFormattedPaginationResults(rawData)
        : { count: 0, schedule: [] },
    isValidating,
    isError,
    ...rest
  };
};

export default useCurriculum;
